function Loader(props) {
  const color = props.color;
  return (
    <div className={`loader -${color}`}>
      <div className={`loader-element -${color}`}></div>
    </div>
  );
}

export default Loader;